(() => {
  const normalize = (value) =>
    String(value || "")
      .trim()
      .toLowerCase();

  function initQuickAddGrind(form) {
    if (!form || form.dataset.grindInitialized === "true") {
      return;
    }

    const wrapper = form.querySelector("[data-quick-add-grind]");

    if (!wrapper) {
      return;
    }

    const grindSelect = wrapper.querySelector(
      'select[name="properties[Grind]"]'
    );

    if (!grindSelect) {
      return;
    }

    form.dataset.grindInitialized = "true";

    function updateGrindSelector() {
      const coffeeFormatInputs = [
        ...form.querySelectorAll("input[data-option-name]")
      ].filter(
        (input) =>
          normalize(input.dataset.optionName) ===
          "coffee format"
      );

      const selectedFormat = coffeeFormatInputs.find(
        (input) => input.checked
      );

      const shouldShowGrind =
        selectedFormat &&
        normalize(selectedFormat.value) === "ground" &&
        !selectedFormat.disabled;

      wrapper.hidden = !shouldShowGrind;
      grindSelect.disabled = !shouldShowGrind;
      grindSelect.required = shouldShowGrind;

      if (!shouldShowGrind) {
        grindSelect.value = "";
      }
    }

    /*
     * React whenever Bag Size or Coffee Format changes.
     */
    form.addEventListener(
      "change",
      () => {
        requestAnimationFrame(updateGrindSelector);
      },
      true
    );

    /*
     * Blockshop replaces the product-options markup
     * after variant changes. Resync once that happens.
     */
    const observer = new MutationObserver(() => {
      requestAnimationFrame(updateGrindSelector);
    });

    observer.observe(form, {
      childList: true,
      subtree: true
    });

    updateGrindSelector();
  }

  function initFormsForHandle(handle) {
    document
      .querySelectorAll(".product-quick-add--form")
      .forEach((form) => {
        if (!handle || form.dataset.handle === handle) {
          initQuickAddGrind(form);
        }
      });
  }

  /*
   * Blockshop fires this when Quick Add opens.
   */
  window.addEventListener(
    "theme:quickAdd:toggle",
    (event) => {
      requestAnimationFrame(() => {
        initFormsForHandle(event.detail);
      });
    }
  );

  /*
   * Initialize any Quick Add forms already in the DOM.
   */
  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      () => initFormsForHandle()
    );
  } else {
    initFormsForHandle();
  }
})();